import React, { useState } from 'react';
import { ThemeProvider } from '../../context/ThemeContext';
import PythonRunner from '../../components/PythonRunner';

function UserActivityPage() {
  const [csvUrl, setCsvUrl] = useState('');

  const taskDescription = `背景：
某电商平台希望分析用户的活跃度，以便进行个性化营销。

数据描述：
你将获得一份用户行为日志数据，包含以下字段：
  • user_id：用户唯一标识
  • event_type：用户行为类型（如浏览、点击、购买）
  • event_time：行为发生的时间戳

任务：
  1. 定义用户的活跃度为其在最近30天内的行为总次数。
  2. 请编写算法，计算每位用户的活跃度。
  3. 将用户按照活跃度从高到低排序，输出前10位用户的user_id和对应的活跃度。
`;

  return (
    <ThemeProvider>
      <div className="p-6 max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">用户活跃度分析任务</h1>

        <pre className="bg-gray-100 p-4 rounded mb-6 whitespace-pre-wrap">{taskDescription}</pre>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Runner</h2>
          <div className="border rounded overflow-hidden">
            <PythonRunner
              initialCode={``}
            />
          </div>
        </div>
        
      </div>
    </ThemeProvider>
  );
}

export default UserActivityPage;